<template>
    <div v-if="show" class="proxy-warning-wrp">Performance of this website is impacted by a content filter or proxy. Please contact your provider to whitelist this website.<span @click="dismiss()" class="proxy-warning-dismiss">Dismiss temporarily</span></div>
</template>

<script>
export default {
    data(){
        return{
            show:false
        }
    },

    methods:{
        dismiss(){
            localStorage.setItem('proxy-warning',new Date())
            this.show = false
        },

        init(){
            if(!localStorage.getItem('proxy-warning')){
                this.show = true
            }else{
                const storedDate = new Date(localStorage.getItem('proxy-warning'))
                const oneday =  60 * 60 * 24 * 1000
                if((new Date() - storedDate) > oneday){
                    this.show = true
                }
            }
            
        }
    }
}
</script>

<style>
.proxy-warning-wrp{
    padding: 15px;
    color: black;
    position: fixed;
    bottom: 0;
    background-color: #FFA500;
    width: 100%;
    text-align: center;
    z-index: 10000;
}

.proxy-warning-dismiss{
    cursor: pointer;
    text-decoration: underline;
    margin-left: 15px;
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/partials/AcceptProxyWarning.vue